import { Link } from 'react-router-dom';
import { trendingArticles, streamers, esportsSchedule } from '../../mocks/articles';

const Sidebar = () => {
  return (
    <aside className="w-full lg:w-80 space-y-6 sm:space-y-8">
      {/* Trending Section */}
      <div className="bg-dark-card rounded-xl sm:rounded-2xl p-4 sm:p-6 border border-dark-border">
        <div className="flex items-center gap-2 mb-4 sm:mb-6">
          <i className="ri-fire-fill text-xl sm:text-2xl text-orange-500"></i>
          <h3 className="font-exo font-bold text-base sm:text-lg bg-gradient-gaming bg-clip-text text-transparent">
            TRENDING BÂY GIỜ
          </h3>
        </div>

        <div className="space-y-3 sm:space-y-4">
          {trendingArticles.map((article, index) => (
            <Link
              key={article.id}
              to={`/bai-viet/${article.slug}`}
              className="flex gap-3 group hover:bg-dark-hover p-2 rounded-lg transition-colors cursor-pointer"
            >
              <div className="relative flex-shrink-0">
                <img
                  src={article.thumbnail}
                  alt={article.title}
                  className="w-16 h-12 sm:w-20 sm:h-16 object-cover rounded-lg"
                  loading="lazy"
                />
                <div className="absolute top-0.5 left-0.5 sm:top-1 sm:left-1 w-4 h-4 sm:w-5 sm:h-5 bg-gradient-gaming rounded-full flex items-center justify-center text-white text-[10px] sm:text-xs font-bold">
                  {index + 1}
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-white text-xs sm:text-sm font-inter font-medium line-clamp-2 group-hover:text-accent-cyan transition-colors">
                  {article.title}
                </h4>
                <div className="flex items-center gap-2 sm:gap-3 mt-1 text-[10px] sm:text-xs text-gray-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.views}
                  </span>
                  <span>{article.timeAgo}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* Streamers Section */}
      <div className="bg-dark-card rounded-xl sm:rounded-2xl p-4 sm:p-6 border border-dark-border">
        <div className="flex items-center gap-2 mb-4 sm:mb-6">
          <i className="ri-star-fill text-xl sm:text-2xl text-yellow-500"></i>
          <h3 className="font-exo font-bold text-base sm:text-lg text-white">
            STREAMER HOT
          </h3>
        </div>

        <div className="space-y-4 sm:space-y-5">
          {streamers.map((streamer) => (
            <div key={streamer.id} className="flex items-center gap-3 sm:gap-4">
              <div className="relative">
                <img
                  src={streamer.avatar}
                  alt={streamer.name}
                  className="w-12 h-12 sm:w-16 sm:h-16 rounded-full border-2 border-accent-cyan object-cover"
                  loading="lazy"
                />
                {streamer.isLive && (
                  <div className="absolute -top-0.5 -right-0.5 sm:-top-1 sm:-right-1 w-4 h-4 sm:w-5 sm:h-5 bg-red-500 rounded-full border-2 border-dark-card animate-pulse"></div>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-white font-inter font-semibold text-sm sm:text-base truncate">
                  {streamer.name}
                </h4>
                <div className="flex items-center gap-2 mt-1 flex-wrap">
                  <span className="px-2 py-0.5 bg-game-fifa/20 text-game-fifa text-[10px] sm:text-xs rounded-full font-medium">
                    {streamer.game}
                  </span>
                  {streamer.isLive && (
                    <span className="flex items-center gap-1 text-[10px] sm:text-xs text-red-500 font-medium">
                      <i className="ri-live-fill"></i>
                      LIVE
                    </span>
                  )}
                </div>
                {streamer.isLive && (
                  <p className="text-[10px] sm:text-xs text-gray-400 mt-1">
                    {streamer.viewers} đang xem
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Esports Schedule */}
      <div className="bg-dark-card rounded-xl sm:rounded-2xl p-4 sm:p-6 border border-dark-border">
        <div className="flex items-center gap-2 mb-4 sm:mb-6">
          <i className="ri-calendar-event-fill text-xl sm:text-2xl text-accent-cyan"></i>
          <h3 className="font-exo font-bold text-base sm:text-lg text-white">
            LỊCH THI ĐẤU
          </h3>
        </div>

        <div className="space-y-3 sm:space-y-4">
          {esportsSchedule.map((match, index) => (
            <div key={match.id} className="relative pl-5 sm:pl-6">
              {/* Timeline */}
              <div className="absolute left-0 top-0 bottom-0 w-0.5 bg-dark-border">
                <div className={`absolute top-2 -left-1 sm:-left-1.5 w-2 h-2 sm:w-3 sm:h-3 rounded-full ${
                  match.isLive ? 'bg-red-500 animate-pulse' : 'bg-accent-cyan'
                }`}></div>
              </div>

              <div className="space-y-1">
                <div className="text-accent-cyan text-[10px] sm:text-xs font-mono font-semibold">
                  {match.time} - {new Date(match.date).toLocaleDateString('vi-VN', { day: '2-digit', month: '2-digit' })}
                </div>
                <div className="text-white font-inter font-semibold text-xs sm:text-sm">
                  {match.teamA} vs {match.teamB}
                </div>
                <div className="text-gray-400 text-[10px] sm:text-xs">
                  {match.tournament}
                </div>
                {match.isLive && (
                  <div className="flex items-center gap-1 text-red-500 text-[10px] sm:text-xs font-semibold mt-1">
                    <i className="ri-live-fill"></i>
                    ĐANG DIỄN RA
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        <Link
          to="/lich-thi-dau"
          className="block mt-4 sm:mt-6 text-center text-accent-cyan hover:text-accent-purple text-xs sm:text-sm font-semibold transition-colors"
        >
          Xem tất cả <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </aside>
  );
};

export default Sidebar;
